<template lang="pug">
infinity-scroll(
  :hasNextPage="canLoadMore"
  @scrolling="onLoadMore"
  :loading="loading"
)
  v-expansion-panels(accordion)
    v-expansion-panel(v-for="(exam, index) in list" :key="index")
      v-expansion-panel-header.pl-6.pr-3
        v-btn(
          @click.stop="onEditClick(exam, index)"
          icon
          x-small
          color="primary"
        ).exam-button.mr-4
          v-icon(small) mdi-pencil
        img(
          :src="getExamImage(exam)"
          alt="exam-img"
        ).mr-4.exam-img
        .exam-name-container
          h4.exam-name {{exam.name}}{{ exam.isDemo ? '(demo)' : '' }}
          .description-text {{exam.description}}
          .license-types {{exam.licenseTypes}}
          .tenant-badges
            .tenant-badge.tenant-wiki(v-if="exam.is_wiki") Wiki
            .tenant-badge.tenant-les(v-if="exam.is_les") Les
            .tenant-badge.tenant-online(v-if="exam.is_online") Online
        statusButton(:status="exam.publicVisible").ml-a.exam-status.mx-2
      v-expansion-panel-content
        v-divider
        v-expansion-panels(accordion multiple)
          v-expansion-panel(v-for="(examType, index) in examTypesForExam(exam)" :key="index")
            v-expansion-panel-header.pl-6.pr-5
              | {{examType.title}}
              span(
                v-show="exam[examType.query].length"
              ).pl-1 ({{ exam[examType.query].length }})
            v-expansion-panel-content
              v-divider
              div
                list(
                  :list="exam[examType.query]"
                  :pagination="pagination"
                  preview-side="right"
                  showMoveButtons
                  hideActions
                  showSelect
                  hideChapters
                  :headers="headers"
                  v-slot="{item}"
                  droppable
                  @itemMoveDown="itemMoveDown($event, exam, examType.query)"
                  @itemMoveUp="itemMoveUp($event, exam, examType.query)"
                  @removeClicked="removeItemFromExam($event, exam, examType.query)"
                  @on-drop="onDrop($event, exam, examType.query)"
                  :isToggleList="false"
                  :isExams="true"
                  :isNonAuto="exam.is_motor || exam.is_scooter"
                )
</template>
<script>
import {AUTO_EXAM_TYPES, NON_AUTO_EXAM_TYPES} from "../core/exam-const"

export default {
  components: {
    list: () => import('@/app/exercise/modules/trainings/components/TrainingsList.vue'),
    infinityScroll: () => import('@/components/global/infinityScroll.vue'),
    statusButton: () => import('@/app/exercise/components/StatusButton'),
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    pagination: Object,
    loading: Boolean,
  },
  computed: {
    canLoadMore() {
      if (this.pagination) {
        return !this.loading && this.pagination.count > this.list.length
      }
      return false;
    },
  },
  watch: {
    pagination(val) {
      this.page = 1;
    },
  },
  data: () => ({
    headers: [
      { text: '' },
      { text: '' },
      { text: '' },
      { text: 'Short name', sortable: false },
      { text: 'Category', align: 'center', sortable: false },
    ],
    page: 1,
  }),
  methods: {
    examTypesForExam(exam) {
      if(exam.is_scooter || exam.is_motor) return Object.values(NON_AUTO_EXAM_TYPES);
      return Object.values(AUTO_EXAM_TYPES);
    },
    getExamImage(exam) {
      return exam.thumbnail ? exam.thumbnail : require('@/assets/img/chapters/chapter-img.png');
    },
    onDrop({event, index}, exam, examType) {
      const item = event.dataTransfer.getData("item");
      const itemObject = JSON.parse(item);
      this.$emit('addItemToExam', exam, itemObject, examType, index);
    },
    onEditClick(exam, index) {
      this.$emit('onEditClick', exam, index);
    },
    updateExam(exam) {
      this.$emit('updateExam', exam)
    },
    removeItemFromExam(item, exam, examType) {
      this.$emit('removeItemFromExam', exam, item, examType);
    },
    itemMoveDown(index, exam, examType) {
      exam.moveItem('down', index, examType);
      this.updateExam(exam)
    },
    itemMoveUp(index, exam, examType) {
      exam.moveItem('up', index, examType);
      this.updateExam(exam)
    },
    onLoadMore() {
      this.page += 1;
      this.$emit('loadMoreClick', this.page);
    },
  },
}
</script>
<style lang="scss" scoped>
  .v-expansion-panel::v-deep{
    .v-expansion-panel.v-expansion-panel--active,
    &.v-expansion-panel--active{
      > .v-expansion-panel-header .v-expansion-panel-header__icon {
        .v-icon {
          transform: rotate(0deg);
        }
      }
    }
    .v-expansion-panel-header .v-expansion-panel-header__icon {
      .v-icon {
        transform: rotate(-90deg);
        color: $primary-color!important;
      }
    }
    .v-expansion-panel-content__wrap {
      padding: 0;
    }
  }
  .exam-img {
    max-width: 40px;
    border-radius: 50%;
  }
  .exam-status {
    flex: 0!important;
    pointer-events: none;
  }
  .exam-name {
    white-space: nowrap;
    display: inline-block;
  }
  .exam-name-container {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .exam-button {
    flex: 0 1 auto!important;
    min-width: 22px;
    width: 22px;
  }
  .infinity-scroll__container ::v-deep {
    height: 100%;
    > div {
      height: 100%!important;
      overflow-y: auto!important;
    }
  }
  .license-types {
    font-size: 12px;
    color: #9e9e9e;
    margin-top: 4px;
  }

  .tenant-badges {
    display: flex;
    gap: 4px;
    flex-wrap: wrap;
  }
  
  .tenant-badge {
    font-size: 11px;
    padding: 2px 8px;
    border-radius: 12px;
    font-weight: 500;
    text-transform: uppercase;
    margin-top: 4px;
    display: inline-block;
    
    &.tenant-wiki {
      background-color: #e3f2fd;
      color: #1976d2;
    }
    
    &.tenant-les {
      background-color: #f3e5f5;
      color: #7b1fa2;
    }
    
    &.tenant-online {
      background-color: #e8f5e8;
      color: #388e3c;
    }
  }
</style>
